import { CliOauthResult } from "pages/cli-oauth-result";

const CliOauthError: React.FC = (): JSX.Element => (
  <CliOauthResult
    message={"Close this tab and retry from the CLI."}
    title={"Sign in failed"}
  />
);

export { CliOauthError };
